import { LocationDto } from '../../modals/GoogleMaps/types';

export const formatAddressLine = (autofilledAddress: LocationDto) => {
  if (!autofilledAddress?.streetNumber && !autofilledAddress?.streetName) return;
  if (autofilledAddress?.streetNumber && !autofilledAddress?.streetName) return autofilledAddress?.streetNumber;
  if (!autofilledAddress?.streetNumber && autofilledAddress?.streetName) return autofilledAddress?.streetName;
  return `${autofilledAddress?.streetNumber} ${autofilledAddress?.streetName}`;
};
